import React, { useState, useEffect } from 'react';
import { CarouselContainer, CarouselWrapper, CarouselTrack, CarouselButton, SectionTitle } from './style';
import { AdItem } from '../';
import { useTranslation } from 'react-i18next';

const FeaturedAdsCarousel = ({ ads, loading }) => {
  const { t } = useTranslation();
  const [currentIndex, setCurrentIndex] = useState(0);
  const [itemsPerView, setItemsPerView] = useState(8);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 600) {
        setItemsPerView(2);
      } else if (window.innerWidth < 900) {
        setItemsPerView(4);
      } else if (window.innerWidth < 1200) {
        setItemsPerView(6);
      } else {
        setItemsPerView(8);
      }
    };

    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const maxIndex = Math.max(0, ads.length - itemsPerView);

  const goToPrevious = () => {
    setCurrentIndex((prev) => Math.max(0, prev - 1));
  };

  const goToNext = () => {
    setCurrentIndex((prev) => Math.min(maxIndex, prev + 1));
  };

  if (loading || ads.length === 0) return null;

  return (
    <CarouselContainer>
      <SectionTitle>{t('featuredAds')}</SectionTitle>
      <CarouselWrapper>
        {currentIndex > 0 && (
          <CarouselButton direction="left" onClick={goToPrevious}>
            ‹
          </CarouselButton>
        )}
        <CarouselTrack offset={currentIndex} itemsPerView={itemsPerView}>
          {ads.map((item, key) => (
            <div key={key} className="carousel-item">
              <AdItem data={item} />
            </div>
          ))}
        </CarouselTrack>
        {currentIndex < maxIndex && (
          <CarouselButton direction="right" onClick={goToNext}>
            ›
          </CarouselButton>
        )}
      </CarouselWrapper>
    </CarouselContainer>
  );
};

export default FeaturedAdsCarousel;
